import React from "react";
import { Chip } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import GenericCrudPage from "../../components/shared/GenericCrudPage";
import {
  adminGetProducts, adminCreateProduct, adminUpdateProduct,
  adminGetProductCategories, adminGetVendors,
} from "../../api/business";

const PRODUCT_TYPE_OPTIONS = [
  { value: "HARDWARE", label: "Hardware" },
  { value: "SOFTWARE", label: "Software" },
];

export default function ProductsPage() {
  const { data: categories = [] } = useQuery({
    queryKey: ["admin-product-categories-lookup"],
    queryFn: () => adminGetProductCategories().then((r) => (Array.isArray(r.data) ? r.data : r.data.results)),
  });
  const { data: vendors = [] } = useQuery({
    queryKey: ["admin-vendors-lookup"],
    queryFn: () => adminGetVendors().then((r) => (Array.isArray(r.data) ? r.data : r.data.results)),
  });

  return (
    <GenericCrudPage
      title="Products"
      queryKey="admin-products"
      listFn={adminGetProducts}
      createFn={adminCreateProduct}
      updateFn={adminUpdateProduct}
      emptyItem={{
        name: "", slug: "", category: "", vendor: "", product_type: "HARDWARE",
        short_description: "", detailed_description: "", specifications: "",
        image: "", is_featured: false, order_index: 0, is_active: true,
        meta_title: "", meta_description: "",
      }}
      // getId/openEdit note: category & vendor come back as nested objects on GET
      // ({ id, name, ... }) but must be sent as plain PK ids on write — the
      // select below already stores an id, so when opening an existing row
      // for edit we flatten the nested object down to just its id.
      columns={[
        { key: "name", label: "Name" },
        { key: "category", label: "Category", render: (r) => <Chip size="small" label={r.category?.name} /> },
        { key: "vendor", label: "Vendor", render: (r) => r.vendor?.name },
        { key: "product_type", label: "Type" },
        { key: "is_active", label: "Active", render: (r) => (r.is_active ? "Yes" : "No") },
      ]}
      formFields={[
        { name: "name", label: "Name", required: true },
        { name: "slug", label: "Slug", required: true },
        {
          name: "category", label: "Category", type: "select", required: true,
          options: categories.map((c) => ({ value: c.id, label: c.name })),
        },
        {
          name: "vendor", label: "Vendor", type: "select", required: true,
          options: vendors.map((v) => ({ value: v.id, label: v.name })),
        },
        { name: "product_type", label: "Type", type: "select", options: PRODUCT_TYPE_OPTIONS, required: true },
        { name: "short_description", label: "Short Description", type: "textarea", required: true },
        { name: "detailed_description", label: "Detailed Description", type: "textarea", required: true },
        { name: "specifications", label: "Specifications", type: "textarea" },
        { name: "image", label: "Image", type: "file" },
        { name: "is_featured", label: "Featured", type: "switch" },
        { name: "order_index", label: "Order Index", type: "number" },
        { name: "meta_title", label: "Meta Title" },
        { name: "meta_description", label: "Meta Description", type: "textarea" },
      ]}
    />
  );
}